import { useCallback, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { AuthContext } from '../contexts/AuthContext';
import { StandupPendencias } from '../types';

/**
 * Busca as pendências do colaborador (stand-ups faltantes + dias de ponto
 * incompletos). Usado no badge da navegação e na seção "Pendências" do dashboard.
 */
export function useStandupPendencias(): {
  data: StandupPendencias | null;
  missingStandups: number;
  incompleteWorkDays: number;
  loading: boolean;
  refresh: () => Promise<void>;
} {
  const { user } = useContext(AuthContext) || {};
  const [data, setData] = useState<StandupPendencias | null>(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async (): Promise<void> => {
    if (!user) {
      setData(null);
      return;
    }
    setLoading(true);
    try {
      const res = await api.get<StandupPendencias>('/standups/pendencias');
      setData(res.data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    void refresh();
    if (!user) return;
    const id = window.setInterval(() => void refresh(), 120000);
    return () => window.clearInterval(id);
  }, [user, refresh]);

  return {
    data,
    missingStandups: data?.missingStandups ?? 0,
    incompleteWorkDays: data?.incompleteWorkDays ?? 0,
    loading,
    refresh,
  };
}
